/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import Modal from '../../ui/Modal';
import Search from '../../ui/Search';
import { DARK_THEME } from '../../ui/Search/constants';
import { NAV } from '../../../utils/constants';
import { colorsPalette } from '../../../styles/colors';
import WaysToWork from './WaysToWork';
import Contact from './Contact';
import { Container, Row } from '../../../styles/Grid';
import { NavConsumer, navbar_finite_state } from '../../../contexts/NavContext';
import Nav from './Nav';
import { defaultData } from './defaultData';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  navCss,
  navContainerCss,
  darkMode,
  containerModalCss,
  modalRowSearchCss,
  rowModalCss,
  modalCss,
  menuContentArea,
} from './index.styles';

const menuToRender = {
  [navbar_finite_state.INITIAL]: () => {},
  [navbar_finite_state.WAYS_TO_WORK]: fields => <WaysToWork fields={fields} />,
  [navbar_finite_state.CONTACT]: (fields, rendering) => (
    <Contact fields={fields} rendering={rendering} />
  ),
  [navbar_finite_state.SEARCH]: fields => {
    const { NavigationItems, RichFiltering } = fields;
    const richFiltering = get(RichFiltering, 'value', false);

    return (
      <Search
        richFiltering={richFiltering}
        workspaceOptions={NavigationItems.value}
        hasRow={false}
        theme={DARK_THEME}
        replaceSearchButtonWithIcon
        parent={NAV}
      />
    );
  },
};

export class NavBar extends SafePureComponent {
  state = {
    isModalOpen: false,
    clickedItem: navbar_finite_state.INITIAL,
  };

  safeRender() {
    const fields = defaultsDeep(this.props.fields, defaultData);
    const membership = fields.Membership;
    const waysToWorkText = fields.WaysToWorkText;

   
    const { rendering, sitecoreContext } = this.props;
    const language = get(sitecoreContext, 'route.itemLanguage', '')
      .replace(/sr-Latn-RS/i, 'sr-rs')
      .replace(/tg-Cyrl-TJ/i, 'tg-tj')
      .replace(/az-Latn-az/i, 'az-az');

    return (
      <NavConsumer>
        {({ isModalOpen, closeModal, openModal, clickedItem }) => (
          <div css={[navContainerCss, isModalOpen && darkMode]}>
            <React.Fragment>
              <Container>
                {console.log('**clickedItem', clickedItem)}
                <nav css={[navCss, isModalOpen && darkMode]}>
                  <Nav
                    clickedItem={clickedItem}
                    language={language}
                    membership={membership}
                    onClickItem={openModal}
                    waysToWorkText={waysToWorkText}
                  
                  />
                </nav>
              </Container>
              <Modal
                overlayProp={modalCss}
                hideDefaultCloseButton
                contentBackground={colorsPalette.black}
                isOpen={isModalOpen}
                onRequestClose={closeModal}
              >
                <Container css={containerModalCss}>
                  <div css={[navCss, isModalOpen && darkMode]}>
                    <Nav
                      clickedItem={clickedItem}
                      closeModal={closeModal}
                      isModalOpen={isModalOpen}
                      language={language}
                      membership={membership}
                      onClickItem={openModal}
                     
                      waysToWorkText={waysToWorkText}
                    />
                  </div>
                  <Row
                    css={[
                      clickedItem === navbar_finite_state.SEARCH &&
                        modalRowSearchCss,
                      clickedItem === navbar_finite_state.CONTACT &&
                        rowModalCss,
                      clickedItem === navbar_finite_state.WAYS_TO_WORK &&
                        menuContentArea,
                    ]}
                  >
                    {menuToRender[clickedItem](fields, rendering)}
                  </Row>
                </Container>
              </Modal>
            </React.Fragment>
          </div>
        )}
      </NavConsumer>
    );
  }
}

NavBar.displayName = 'NavBar';

NavBar.defaultProps = {
  t: key => key,
};

export default withSitecoreContext()(NavBar);
